module.exports = __webpack_public_path__ + "img/text-indent-left.743cf961.svg";